var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 3.891v8.765a2.531 2.531 0 002.53 2.531h5.766a1.595 1.595 0 01-1.453.938H6.844a3.469 3.469 0 01-3.469-3.469V5.344a1.594 1.594 0 01.938-1.453zm5.346-2.016a1.593 1.593 0 011.127.467l3.372 3.372a1.593 1.593 0 01.467 1.127v5.815a1.594 1.594 0 01-1.594 1.594H6.844a1.594 1.594 0 01-1.594-1.594V3.47a1.594 1.594 0 011.594-1.594h2.815zm-.284.938H6.844a.656.656 0 00-.657.656v9.187c0 .363.294.656.657.656h6.187a.656.656 0 00.656-.656V7.125H10.97a1.594 1.594 0 01-1.592-1.516l-.002-.078V2.813zm3.93 3.374l-2.992-2.993v2.337a.656.656 0 00.602.654l.054.003h2.337z"
  })));
}
export default SvgCopyTextIcon;